export const API_URL = "http://localhost:5000/api"